import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "primereact/dropdown";
import { useCallback, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import { getStations } from "../services/sl";
import { useLocale } from "../stores/locale";
import { Station } from "../types/station";
import { PrimeButton } from "./prime/button";

type CloseByStation = Station & {
  distance: number;
  distanceInMeters: number;
};

export function CloseByStations() {
  const t = useLocale((state) => state.locale);

  const [position, setPosition] = useState<GeolocationPosition | null>(null);
  const [closeByStations, setCloseByStations] = useState<Station[]>([]);

  const updatePosition = useCallback(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setPosition(position);
    });
  }, []);

  // Get current location
  useEffect(() => {
    updatePosition();
  }, [updatePosition]);

  useEffect(() => {
    if (position) {
      (async () => {
        const stations = await getCloseByStations(position);
        setCloseByStations(stations);
      })();
    }
  }, [position]);

  const itemTemplate = (option: CloseByStation) => {
    return (
      <NavLink className="grow px-2 py-1.5" to={`?station=${option.id}`}>
        {option.name} ({option.distanceInMeters}m)
      </NavLink>
    );
  };

  return (
    <>
      <Dropdown
        itemTemplate={itemTemplate}
        options={closeByStations}
        placeholder={t.departures.closeByStations}
        pt={{
          item: {
            className: "!p-0 flex",
          },
          itemLabel: {
            className: "flex grow",
          },
        }}
      />
      <PrimeButton
        icon={<FontAwesomeIcon icon={faRefresh} />}
        onClick={() => {
          updatePosition();
        }}
      />
    </>
  );
}

async function getCloseByStations(
  position: GeolocationPosition,
): Promise<CloseByStation[]> {
  const stations = await getStations();
  return stations
    .reduce((acc: CloseByStation[], station) => {
      if (!station.lat || !station.lon) {
        return acc;
      }
      const distance = Math.sqrt(
        (station.lat - position.coords.latitude) ** 2 +
          (station.lon - position.coords.longitude) ** 2,
      );

      if (distance < 0.005) {
        acc.push({
          ...station,
          distance,
          distanceInMeters: Math.round(distance * 1000) * 100,
        });
      }

      return acc;
    }, [])
    .sort((a, b) => a.distance - b.distance);
}
